<div
  *ngIf="checkout"
  [opacTooltip]="'tooltip.disabledReturn' | translate"
  [tooltipDisabled]="checkout.returnable">
  <button
    *ngIf="!isMoreOption"
    class="warn transparent"
    mat-flat-button
    [class.waiting]="waiting"
    [disabled]="!checkout.returnable"
    appStopPropagation
    (click)="showReturnCheckoutDialog.set(true)">
    <ng-container *ngIf="!waiting"> {{ 'button.return' | translate }} </ng-container>

    <mat-spinner *ngIf="waiting" [diameter]="20"></mat-spinner>
  </button>
  <button
    *ngIf="isMoreOption"
    class="warn transparent"
    mat-menu-item
    [class.waiting]="waiting"
    [disabled]="!checkout.returnable"
    appStopPropagation
    (click)="showReturnCheckoutDialog.set(true)">
    <ng-container *ngIf="!waiting">
      <span class="odilo-icon" aria-hidden="true">delete</span>
      <span class="text" aria-hidden="true">{{ 'button.return' | translate }}</span>
    </ng-container>

    <mat-spinner *ngIf="waiting" [diameter]="20"></mat-spinner>
  </button>
</div>

<ng-container *ngIf="isHoldItem">
  <button
    *ngIf="isMoreOption"
    class="warn transparent"
    mat-menu-item
    [class.waiting]="waiting"
    appStopPropagation
    (click)="cancelHold()">
    <ng-container *ngIf="!waiting">
      <span class="odilo-icon" aria-hidden="true">delete</span>
      <span class="text" aria-hidden="true">{{ 'button.cancelHold' | translate }}</span>
    </ng-container>

    <mat-spinner *ngIf="waiting" [diameter]="20"></mat-spinner>
  </button>
</ng-container>

<opac-confirmation-dialog
  appStopPropagation
  [acceptLabel]="'general.return'"
  [open]="showReturnCheckoutDialog()"
  [title]="'general.return.checkout' | translate"
  (accept)="doReturn()"
  (cancel)="showReturnCheckoutDialog.set(false)">
  <p>{{'messages.checkout.confirmRemove' | translate}}</p>
</opac-confirmation-dialog>